import React from 'react';
import '../style/toba.css'
import BASE_URL from "../cycles/variables";
import GeneralSVG from "./generalSVG";
import FormResponseMessage from "./formResponseMessage";

const SolicitorHomePage = (props) => {

    return (
        <div className="row">
            <div className="col-sm-12">
                {
                    (props.failedToReceivePendingTobaMsg) ?
                        <div className="row">
                            <div className="col-sm-12">
                                <form className="form-horizontal">
                                    <FormResponseMessage
                                        LeftWrapper=""
                                        CenterWrapper="col-sm-12"
                                        MessageStyle="formResponseMessage-reject"
                                        Message={props.failedToReceivePendingTobaMsg}/>
                                </form>
                            </div>
                        </div>
                        :
                        null

                }
                <div className="row">
                    <div className="col-sm-12">
                        <h2 className="header2Style">News & Articles</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        {
                            props.articles.map((article, index) => {
                                if (index <= 2) {
                                    return <div className="" key={index}>
                                        <div className="row">
                                            <div className="col-sm-12">
                                        <span className="articleModal-title">
                                            {article.title}
                                        </span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12" dangerouslySetInnerHTML={{__html: article.body}}>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                {
                                                    article.attatchmentDtos.length > 0 ?

                                                        <ul className="solicitorArticlesList-modal-attachments-ul">
                                                            {
                                                                article.attatchmentDtos.map((attachment, index) => {
                                                                    return <li key={index}>
                                                                        <a onClick={() => props.requestGetArticleAttachment({
                                                                            articleId: article.id,
                                                                            attachmentId: attachment.id
                                                                        })}
                                                                           className="applicationPolicy-document-tab-link">
                                                                            <GeneralSVG
                                                                                SvgWrapper="generalTab-download-wrapper inlineBlock"
                                                                                Label="Download"
                                                                                Svg={<svg
                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                    viewBox="0 0 10 10">
                                                                                    <title>Asset 9</title>
                                                                                    <g id="Layer_2" data-name="Layer 2">
                                                                                        <g id="info">
                                                                                            <path
                                                                                                d="M9.5,6a.5.5,0,0,0-.5.5V9H1V6.5a.5.5,0,0,0-1,0V10H10V6.5A.5.5,0,0,0,9.5,6Z"/>
                                                                                            <path
                                                                                                d="M5,7.21,7.35,4.85a.5.5,0,0,0-.71-.71L5.5,5.29V0h-1V5.29L3.35,4.15a.5.5,0,0,0-.71.71Z"/>
                                                                                        </g>
                                                                                    </g>
                                                                                </svg>}
                                                                            />
                                                                        </a>
                                                                        {' '}
                                                                        {attachment.name}
                                                                    </li>
                                                                })

                                                            }
                                                        </ul>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <hr className="appFormRefSettings-hr"/>
                                            </div>
                                        </div>

                                    </div>
                                }
                                else return null
                            })
                        }
                        <div className="inlineBlock" onClick={() => props.push('/articles')}>
                            <GeneralSVG
                                SvgWrapper="solicitorArticlesList-readArticle-wrapper inlineBlock"
                                Label={'View All Articles'}
                                Svg={<svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 9.6 16"><title>
                                    Asset
                                    2</title>
                                    <g id="Layer_2"
                                       data-name="Layer 2">
                                        <g id="Layer_1-2"
                                           data-name="Layer 1">
                                            <path
                                                d="M9.6,8.08a1.63,1.63,0,0,1-.48,1.16L2.81,15.53A1.63,1.63,0,0,1,.52,13.21L5.68,8.07.47,2.78A1.63,1.63,0,1,1,2.78.49L9.13,6.94A1.63,1.63,0,0,1,9.6,8.08Z"/>
                                        </g>
                                    </g>
                                </svg>}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SolicitorHomePage;